import { render } from "./SliderBlock.vue?vue&type=template&id=0d5d6210&scoped=true&ts=true"
import script from "./SliderBlock.vue?vue&type=script&lang=ts"
export * from "./SliderBlock.vue?vue&type=script&lang=ts"

import "./SliderBlock.vue?vue&type=style&index=0&id=0d5d6210&lang=scss&scoped=true"
import "./SliderBlock.vue?vue&type=style&index=1&id=0d5d6210&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5d6210"]])

export default __exports__